import styles from "./PrintQuarterSize.module.css";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";

import sample_1 from "../../../assets/images/edit_screen/PrintQuarterSize/sample_1.png";
import PrintQuarterSizeReusable from "./PrintQuarterSize_Reusable";

import plus_icon from "../../../assets/images/icons/plus_inside_circle.png";

//Page Specific Reusable
import { useEffect, useState } from "react";
import PhotoSelection from "../PhotoSelection/PhotoSelection";
import save_icon from "../../../assets/images/icons/save_icon.png";

import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../Hooks/useAxios";

const PrintQuarterSize = () => {
  const { product_id } = useParams();
  const allImagesPicked = () => {
    let current = editState.reduce((total, item) => total + item.count, 0);
    if (current < count) {
      return false;
    }
    return true;
  };
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  console.log("PRODUCT CODE IS: ");
  console.log(product_id);
  const [item, setItem] = useState({});
  const [count, setCount] = useState(0);

  const [showSelectionPopup, setShowSelectionPopup] = useState(false);

  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);

  let [editState, setEditState] = useState([]);

  const imageSelectionPopup = (count) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setpsk(psk + 1);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    console.log(photo_url[0]);
    const temp = Array.from(editState);
    temp.push({
      src: photo_url[0],
      count: 1,
    });
    setEditState(temp);
  };

  const confirmEdits = () => {
    if (!allImagesPicked()) {
      setShowModal(true);
      return;
    }
    console.log("Confirm Edits. Send to server");
    console.log(editState);
    const tempDetails = editState;

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "写真プリント", subtitle : "四つ切りサイズ", count : count, address : "", item : item } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
          } else {
            let tempState = [];

            setEditState(tempState);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"写真プリント"}
            subtitle={"四つ切りサイズ"}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <div className={styles.spacing01}></div>
          <EditScreenHeaderInfoDiv lines={["写真を選択してください。"]} />
          <div className={styles.spacing02}></div>
          <div className={styles.hr01}></div>
          <div className={styles.sample_header01}>Sample</div>
          <div className={styles.sample_images}>
            <img src={sample_1} width={298} height={356} alt="sample" />
          </div>
          {count > 0 && (
            <PrintQuarterSizeReusable
              count={count}
              state={editState}
              callback={setEditState}
              image_selection_popup={imageSelectionPopup}
            />
          )}

          {count > 0 && (
            <div className={styles.confirm_edits}>
              <div className={styles.confirm_header}>
                上記の内容でデザイン決定しますか？
              </div>
              <div className={styles.confirm_button_section}>
                <button
                  onClick={() => {
                    navigate("/design-box");
                  }}
                  className={styles.confirm_button_no}
                >
                  編集へ戻る
                </button>
                <button
                  onClick={confirmEdits}
                  className={styles.confirm_button_yes}
                >
                  はい
                </button>
              </div>
            </div>
          )}
          {count === 0 && <div className={styles.nopage_margin_bottom}></div>}
          {showModal && (
            <div className={styles.incomplete_modal_main}>
              <div className={styles.modal_head01}>
                <div>残り○枚お選びいただけます。</div>
                <div>枚数を変更するか、</div>
                <div>写真を追加してください。</div>
              </div>
              <div className={styles.modal_head02}>
                <img
                  onClick={() => {
                    imageSelectionPopup(1);
                    setShowModal(false);
                  }}
                  src={plus_icon}
                  className={styles.plus_icon_modal}
                  alt="plus"
                />
                追加写真選択
              </div>
              <div
                onClick={() => {
                  setShowModal(false);
                }}
                className={styles.modal_close}
              >
                <ion-icon
                  className={styles.modal_cross_icon}
                  name="close"
                ></ion-icon>
              </div>
            </div>
          )}
        </div>
      )}
      <Footer />
    </>
  );
};

export default PrintQuarterSize;
